import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IBoardEmailPanelButtonProps } from './types';
import { BOARD_SECTION_EMAIL } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function BoardEmailPanelButton ({
    tooltip,
    onClick
}: IBoardEmailPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.BOARD_EMAIL}
            title={BOARD_SECTION_EMAIL}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.BOARD_EMAIL);
                onClick();
            }}
        />
    );
}
